/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `paper` - Papier
* `computer` - Ordinateur
* `` - Non précisé
 */
export type ExamSessionModeEnum = typeof ExamSessionModeEnum[keyof typeof ExamSessionModeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExamSessionModeEnum = {
  paper: 'paper',
  computer: 'computer',
} as const;
